import { Directive, TemplateRef, ViewContainerRef, Input } from "@angular/core";
import { IAppStore } from "../iappstore";
import { Store } from "@ngrx/store";

@Directive({
    selector: "[featureToggle]",
    standalone: true
})
export class FeatureToggleDirective {
    private hasView = false;

    constructor(private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private store: Store<IAppStore>) {
    }

    @Input()
    set featureToggle(featureId: number) {
        this.store.select(e => e.user.selectedBusinessFunction)
            .subscribe(bf => {
                if (bf && bf.features && bf.features.findIndex(e => e.featureId === featureId && e.enabled) > -1 && !this.hasView) {
                    this.viewContainer.createEmbeddedView(this.templateRef);
                    this.hasView = true;
                } else {
                    this.viewContainer.clear();
                    this.hasView = false;
                }
            });
    }
}